var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCurriculumLandingStairway2Small = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 346 460",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--text-secondary)",
    d: "M72.627 394.5c-6.589 4-41.455 3.5-41.455 3.5v-3.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--text-secondary)",
    d: "M72.627 394.5c-6.589 4-41.455 3.5-41.455 3.5v-3.5zm0 0c6.589-4 1.53-66.777 5.173-70.516 3.644-3.738 30.616-4.264 32.437-9.5 1.822-5.235 1.726-62.513 3.548-73 1.822-10.486 48.656-8.5 48.656-8.5 0-33.331 4.055-52 6.589-62.466s11.007-13.627 20.78-16.049c9.215-2.284 138.282 4.495 141.406 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--text-primary)",
    strokeWidth: 0.851,
    d: "M30.664 297.99s38.012-10.004 56.765-35.004c13.228-17.635 33.441-84.5 0-88.998-13.137-1.767-20.39 12.492-15.713 25.001 7.886 21.091 46.953 5.955 59.301-10.505 9.374-12.495 20.272-41.498 20.272-41.498m0 0-6.08 1.498m6.08-1.498 3.043 4.998"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#smallm)",
    d: "M127.142 50.53c-8.362 15.957 12.26 20.065 3.898 36.021l205.822-44.627s-6.223-18.062-12.88-24.957c-12.772-13.23-26.142 13.422-40.277 4.558-7.163-4.492-16.059-9.16-23.088-14.175-17.206-12.278-21.821 2.704-40.577 1.678-13.647-.747-30.704-13.265-41.538 0-7.534 9.225-9.59 17.643-17.254 26.586-8.448 9.857-25.744-1.04-34.106 14.917"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.32,
    d: "m171.693 117.058-2.572-3.206m.876 5.993-9.382-1.197"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.641,
    d: "m234.224 153.998.001-119.702"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3642A",
    d: "M259.486 39.148c-12.201-22.28-25.582 3.921-25.582 3.921V94s13.769-20.017 23.899-19.589c7.815.331 11.121 10.789 18.85 13.06 15.54 4.566 23.339-20.073 39.045-18.936 7.191.52 18.177 5.876 18.177 5.876l-13.464-24.159 10.771-16.324s-9.387-3.661-15.484-3.918c-15.78-.663-44.768 30.036-56.212 9.138"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B5AFF",
    fillOpacity: 0.8,
    d: "m251.315 73.87-.19 3.305-2.051-1.63z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0931FF",
    fillOpacity: 0.8,
    d: "m181.043 63.033 1.318 4.694-2.415.092z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0909",
    fillOpacity: 0.8,
    d: "m170.021 50.986 1.798-.31-1.352 2.554zm30 3.623-2.568-1.784 3.631-1.69z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B5AFF",
    d: "m210.97 94.221-2.51 1.913.705-4.848z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0909",
    fillOpacity: 0.8,
    d: "m228.872 79.89-2.568-1.784 3.632-1.69z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#C7B700",
    strokeWidth: 0.641,
    d: "m185.173 51.79-1.624-2.071m17.865 17.403-.325 2.9m-33.132-5.386-2.273 2.9m76.007 19.476v3.314m0-20.303-3.248 2.9m-30.208 2.072 1.624 3.73"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0BE91",
    d: "M238.5 81.088c-5.506 3.548-10.388-1.257-16.84 0-1.663.324-3.158 1.558-3.158 1.558l-3.157-1.558s-3.31.288-5.263 1.038c-4.2 1.614-4.033 8.81-8.42 7.788-4.309-1.003-4.21-10.383-4.21-10.383l-7.368 3.634s1.684 15.872 8.946 16.094c5.682.174 11.052-9.345 11.052-9.345l-1.052 15.056 18.419 1.557-1.579-16.613s11.558.546 17.367-3.115c4.171-2.63 8.42-9.345 8.42-9.345l-6.841-4.673s-2.874 6.09-6.316 8.307"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4D4B8",
    d: "m191.137 70.698-1.053 6.23v2.077l1.579 3.634 4.21-2.077v-.52l1.579-2.594-1.053-1.558h-2.105l1.579-4.672s-1.053-2.596-1.579-.52-2.105 5.191-2.105 5.191.526-3.635.526-5.191-1.578 0-1.578 0m55.784.519-.527 2.596 4.21 3.116s1.334-2.447 2.106-3.116c1.464-1.27 2.337-.167 3.683-1.558 1.987-2.053.77-4.215-.526-6.75-.593-1.158-2.946-1.193-4.21-1.556-1.248-.358-3.997.508-4.736 1.563-.702 1-.27 4.518 0 5.705"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF8F8",
    stroke: "#7C6063",
    strokeWidth: 1.038,
    d: "m177.451 116.422 4.211 3.634s-2.924 8.159-4.211 5.711c-.662-1.26 0-3.634 0-3.634s-2.765 3.876-5.262 3.634c-1.372-.133-3.158-1.558-3.158-1.558z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7C6063",
    strokeWidth: 1.038,
    d: "m178.499 117.977-7.894 7.268"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF8F8",
    stroke: "#7C6063",
    strokeWidth: 1.038,
    d: "m232.876 154.046-2.36-5.004s6.019-6.295 6.192-3.543c.089 1.417-1.49 3.324-1.49 3.324s4.119-2.441 6.303-1.223c1.2.669 2.249 2.684 2.249 2.684z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7C6063",
    strokeWidth: 1.038,
    d: "m232.55 152.209 10.2-3.497"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#94B1EB",
    d: "m202.716 120.025 6.315-15.056 17.893 1.557 8.947 20.767 3.157 16.614-9.473 5.711-5.789-20.248-7.367-10.903-12.631 12.98-26.313-3.115 5.789-9.865z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4D4B8",
    d: "m216.4 81.6.527-2.077h3.684l.24 2.077-2.346 2.077z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4D4B8",
    d: "M224.126 73.584c-.748 3.888-.685 4.325-4.193 6.26-3.545-.325-5.084-.363-6.32-4.429.237-4.353 2.844-6.755 5.876-7.35 2.029.397 5.096 1.372 4.637 5.52"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.519,
    d: "M218.131 77.164c1.066 1.13 2.513.32 3.442-.393z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.519,
    d: "m219.565 75.803 1.564-.306-.689-1.671m.868-1.02c-.041-.201.178-.457.403-.66.307-.278.631-.542 1.002-.356.297.148.393.745.393.745m-6.583 1.21s.043-.485.462-.673c.561-.253.694-.328 1.302-.256.436.053.78.51.78.51m-4.168 4.694s1.928 2.014 4.775 1.686c.576-.066 1.389-.503 1.389-.503"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M223.398 67.643c.426.573.73 1.232.876 1.956.185.916.144 1.218-.098 1.189.117.481.486 2.079.319 2.41-.198.392-.467 1-.467 1s-.152-.643-.212-2.426c-.022-.651-.13-1.058-.258-1.312l-.202-.137q-.165-.115-.353-.24a10 10 0 0 0-1.213-.703c-.211-.1-.421-.286-.64-.48-.412-.364-.854-.755-1.385-.651-.322.063-.68.2-1.055.389l-3.679 2.706-.147.133-.098 2.227s-.444.54-.372.896l.478 2.374s-.021.519-.106.844c-.233.887-.478 1.546-1.386 2.035-.46.247-1.816.59-1.816.59s1.412-1.145 1.831-1.886c.214-.38.282-.72.359-1.105l.055-.27c.35-1.617-.509-3.896-.509-3.896l-.058.002c-.225.192-.507.33-.963.42-.272-.034-.415-.685-.517-1.191-.199-.988-.092-2.023.266-2.99-.428-.156-.783-.413-1.012-.765-.673-1.037.003-2.504 1.51-3.277 1.306-.67 2.806-.6 3.622.105a6 6 0 0 1 .706-.18 7.4 7.4 0 0 1 1.864-.128c.37-1.082 1.823-1.821 3.399-1.685 1.692.146 2.885 1.247 2.665 2.458-.123.676-.66 1.244-1.404 1.588",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.519,
    d: "M215.347 81.099s-.526-.52-5.262 1.038c-4.737 1.558-2.632 5.194-6.316 7.269-3.683 2.074-5.789-4.675-5.789-4.675"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M192.98 70.204a.26.26 0 0 0-.517-.048zm-.785 5.687-.258-.024.502.114zm3.684-4.672.246.083.025-.073-.019-.074zM194.3 75.89l-.246-.083-.158.47.476-.138zm2.105 0 .128-.226zm-.526 4.153-.207-.156-.052.07v.087zm-3.416-9.888-.526 5.711.517.048.526-5.711zm-.268 5.735.244.09v-.001l.001-.003.005-.012.018-.048.067-.182.245-.653c.206-.543.485-1.271.78-2.016s.606-1.504.876-2.107c.134-.302.257-.562.361-.761.111-.211.184-.32.217-.352l-.364-.37c-.1.098-.207.28-.312.48-.112.213-.24.485-.377.791-.273.613-.587 1.38-.884 2.127a149 149 0 0 0-1.114 2.91l-.005.013-.001.003v.001zm2.814-6.045c.024-.024.016-.005-.015-.009-.017-.002-.005-.007.037.034.085.084.184.255.281.478.094.215.173.448.229.63.028.09.049.167.064.22l.017.063.004.016.001.003.001.001.251-.063.252-.064-.001-.002-.001-.005-.005-.019-.018-.068a7 7 0 0 0-.318-.919c-.1-.23-.231-.481-.393-.64a.6.6 0 0 0-.343-.18.5.5 0 0 0-.407.154zm.624 1.29-1.579 4.672.492.166 1.579-4.672zM194.3 75.89l.072.25h.001l.002-.001.01-.003.042-.011a5 5 0 0 1 .688-.128c.433-.05.884-.038 1.163.12l.255-.453c-.435-.245-1.036-.234-1.477-.183a6 6 0 0 0-.76.141l-.049.013-.013.004-.004.001h-.002zm1.978.226c.283.16.516.39.678.637.163.25.242.5.242.695h.52c0-.323-.126-.67-.328-.98a2.5 2.5 0 0 0-.857-.804zm.92 1.332v.003l-.001.01-.008.034q-.012.046-.039.115a3 3 0 0 1-.166.336 12 12 0 0 1-.531.848 26 26 0 0 1-.714 1.004l-.049.066-.013.017-.004.004v.001h-.001l.207.157.207.157.001-.001.004-.005.013-.018.051-.068a27 27 0 0 0 .729-1.023c.199-.295.401-.61.554-.888a4 4 0 0 0 .193-.392 1 1 0 0 0 .087-.357zm-1.578 2.596v.519h.519v-.52z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.519,
    d: "m209.035 105.5-6.315 14.537-19.472-1.558m68.42-41.01s-4.329 7.422-8.947 9.864c-2.291 1.212-6.315 2.077-6.315 2.077m14.726-25.45c.527 2.078-3.685 2.078-2.105 3.116s2.105 2.596 2.105 2.596"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "smallm",
    x1: 223.161,
    x2: 224.806,
    y1: 3.935,
    y2: 84.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--curriculum-bg-color)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "var(--curriculum-bg-color)",
    stopOpacity: 0.567
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "var(--curriculum-bg-color)",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "var(--curriculum-bg-color)",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCurriculumLandingStairway2Small);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/curriculum-landing-stairway-2-small.5f29b4166346689d90867cc9ebd01d1e.svg";